import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { folderManagementFilterSliceInitialState } from "./intialState";

const folderManagementFilterSlice = createSlice({
  name: "fmFilters",
  initialState: () => {
    const initialState = { ...folderManagementFilterSliceInitialState };
    return initialState;
  },
  reducers: {
    setFmActiveTab(state, action: PayloadAction<string>) {
      state.fmActiveTab = action.payload;
      return state;
    },

    setFmNestedActiveTab(state, action: PayloadAction<string>) {
      state.fmNestedTab = action.payload;
      return state;
    },

    setFmActiveTabFolderCount(state, action: PayloadAction<number>) {
      state.fmActiveTabFolderCount = action.payload;
      return state;
    },
    setFmNestedActiveTabFolderCount(state, action: PayloadAction<number>) {
      state.fmNestedActiveTabFolderCount = action.payload;
      return state;
    },
    setFmStateName(state, action: PayloadAction<string>) {
      state.stateName = action.payload;
      return state;
    },
    setFmNestedStateName(state, action: PayloadAction<string>) {
      state.nestedStateName = action.payload;
      return state;
    },
    setCurrentState(state, action: PayloadAction<any>) {
      state.currentState = action.payload;
      return state;
    }
  },
});

export const {
  setFmActiveTab,
  setFmNestedActiveTab,
  setFmActiveTabFolderCount,
  setFmNestedActiveTabFolderCount,
  setFmStateName,
  setFmNestedStateName,
  setCurrentState
} = folderManagementFilterSlice.actions;

export default folderManagementFilterSlice;
